<template>
  <div class="main">
    <div class="lists">
      <ul>
        <li
          v-for="(item, index) in typeList"
          :key="item.id"
          :class="{ current: item.id == currentid }"
          @click="setList(item.id)"
        >
          <a-avatar :size="24" :src="item.icon" class="icon" />
          {{ item.name }}
          <span class="operate2"> </span>
          <span class="operate">
            <a-icon
              type="up"
              class=" soft dynamic-ok-button"
              @click="sort('up', item, index)"
              style="top:-10px;left:17px"
            />
            <a-icon
              type="down"
              class=" soft dynamic-ok-button"
              @click="sort('down', item, index)"
              style="top:6px;left:0px"
            />
            <a-icon
              class="dynamic-ok-button"
              type="edit"
              @click="typeEdit(index)"
            />
            <a-icon
              class="dynamic-delete-button"
              type="delete"
              @click="deleteType(item.id)"
            />
          </span>
        </li>
        <li class="type" v-if="busy">
          <a-input
            placeholder="请填写类别名称"
            v-model="typeParam.name"
            style="width:70%;"
          />
          <a-icon
            class="dynamic-ok-button"
            type="check-circle-o"
            @click="saveType"
          />
          <a-icon
            class="dynamic-delete-button"
            type="minus-circle-o"
            @click="addType"
          />
        </li>
        <li class="add" @click="addType" v-else>
          <a-icon type="plus" />
        </li>
      </ul>
    </div>
    <div class="itemList">
      <div class="button">
        <a-button
          type="primary"
          style="background-color:#52c41a;border-color:#52c41a;"
          @click="addTel()"
        >
          <a-icon type="plus" />新增电话
        </a-button>
      </div>
      <ul class="item" v-if="itemList.length > 0">
        <li v-for="(item, index) in itemList" :key="index">
          <span>[id:{{ item.id }}]</span>
          {{ item.title }}
          <div class="operate">
            <a-button type="link" @click="itemEdit(index)">编辑</a-button>
            <a-button type="link" @click="itemDelete(index)">删除</a-button>
          </div>
        </li>
      </ul>
      <div class="item" v-else>暂无数据</div>
    </div>
    <a-modal
      title="编辑类别名称"
      :visible="TypeVisible"
      @ok="typeEditSave"
      @cancel="typeEditCancel"
    >
      <p>
        <a-form-item label="类别图标">
          <a-upload-dragger
            accept="image/*"
            name="file"
            :multiple="true"
            :headers="headers"
            :beforeUpload="beforeUpload"
            style="display:none;"
          >
            <div ref="imgupload">
              <a-icon type="inbox" />
            </div>
          </a-upload-dragger>
          <a-avatar
            class="change"
            :size="72"
            icon="picture"
            :src="icon"
            @click="uploadImg"
          />
        </a-form-item>
        <a-form-item label="类别图标">
          <a-input v-model="typeName" />
        </a-form-item>
      </p>
    </a-modal>
    <a-modal
      title="便民电话"
      :visible="ItemVisible"
      @ok="itemEditSave"
      @cancel="itemEditCancel"
    >
      <p>
        <a-form-item label="名称">
          <a-input placeholder="请填写名称" v-model="itemParam.title" />
        </a-form-item>
        <a-form-item label="联系电话">
          <a-input placeholder="请填写联系电话" v-model="itemParam.tel[0]" />
          <a-input placeholder="请填写联系电话" v-model="itemParam.tel[1]" />
        </a-form-item>
        <a-form-item label="地址">
          <a-input placeholder="请填写地址" v-model="itemParam.address" />
        </a-form-item>
      </p>
    </a-modal>
    <!-- <SlickList></SlickList> -->
  </div>
</template>

<script>
import { SlickList, SlickItem, HandleDirective } from 'vue-slicksort';

export default {
  name: 'Sort',
  directives: { handle: HandleDirective },
  components: {
    SlickItem,
    SlickList
  },
  data() {
    return {
      currentid: 0,
      typeName: '',
      icon: '',
      TypeVisible: false,
      busy: false,
      typeList: [], //便民电话类别
      typeParam: {
        name: '',
        icon: ''
      },
      itemList: [],
      ItemVisible: false,
      itemParam: {
        id: '',
        title: '',
        tel: [],
        address: ''
      },
      headers: {
        Authorization: window.localStorage.getItem('token')
      },
      imgdata: {
        blob_num: 1,
        total_blob_num: 1,
        file_name: '123.jpg'
      }
    };
  },
  created() {
    this.getTypeList();
  },
  methods: {
    itemDelete(index) {
      let that = this;
      let id = this.itemList[index].id;
      this.$confirm({
        title: '删除确认',
        content: '确定删除该便民电话吗？',
        onOk() {
          that.$http.post('/api/app/quickdel', { ids: id }).then(res => {
            if (res.data.state == 200) {
              that.$message.success('操作成功');
              that.getItemList();
            } else {
              that.$message.warn('删除失败，请和管理员联系');
            }
          });
        },
        onCancel() {}
      });
    },
    itemEdit(index) {
      this.itemParam = this.itemList[index];
      this.itemParam.tel = JSON.parse(this.itemList[index].tel);
      this.ItemVisible = true;
    },
    addTel() {
      this.itemParam = {
        title: '',
        tel: [],
        address: ''
      };
      this.ItemVisible = true;
    },
    itemEditSave() {
      let param = JSON.parse(JSON.stringify(this.itemParam));
      param.typeid = this.currentid;
      param.tel = JSON.stringify(param.tel);
      this.$http.post('/api/app/quickupdate', param).then(res => {
        if (res.data.state == 200) {
          this.$message.success('操作成功');
          this.ItemVisible = false;
          this.getItemList();
        } else {
          this.$message.warn('操作失败');
        }
      });
    },
    getItemList() {
      this.itemList = [];
      let param = { typeid: this.currentid, limit: 200 };
      this.$http.post('/api/app/quicklist', param).then(res => {
        this.itemList = res.data.data;
      });
    },
    itemEditCancel() {
      this.ItemVisible = false;
    },
    getTypeList() {
      this.$http.post('/api/app/quicktypelist', { limit: 200 }).then(res => {
        if (res.data.state == 200) {
          this.currentid = res.data.data[0].id;
          this.getItemList();
        }

        this.typeList = res.data.data;
      });
    },
    addType() {
      this.typeName = '';
      this.currentid = '';
      this.icon = '';
      this.TypeVisible = true;
      // this.busy = !this.busy;
    },
    saveType() {
      this.$http.post('/api/app/quicktypeupdate', this.typeParam).then(res => {
        if (res.data.state == 200) {
          this.busy = false;
          this.getTypeList();
          this.$message.success('操作成功');
        }
      });
      // console.log(this.typeParam.typeName);
    },
    typeEdit(i) {
      this.currentid = this.typeList[i].id;
      this.typeName = this.typeList[i].name;
      this.icon = this.typeList[i].icon;
      this.TypeVisible = true;
    },
    typeEditSave() {
      let param = {
        id: this.currentid,
        name: this.typeName,
        icon: this.icon
      };
      this.$http.post('/api/app/quicktypeupdate', param).then(res => {
        if (res.data.state == 200) {
          this.TypeVisible = false;
          this.getTypeList();
          this.$message.success('保存成功');
        }
      });
    },
    typeEditCancel() {
      this.TypeVisible = false;
    },
    deleteType(id) {
      let that = this;
      this.$confirm({
        title: '确定删除该类别吗？',
        content: '删除类别的同时将删除该类别下的所有电话',
        onOk() {
          that.$http.post('/api/app/quicktypedel', { ids: id }).then(res => {
            if (res.data.state == 200) {
              that.$message.success('操作成功');
              that.getTypeList();
            } else {
              that.$message.warn('删除失败，请和管理员联系');
            }
          });
        },
        onCancel() {}
      });
    },
    setList(id) {
      this.currentid = id;
      this.getItemList();
    },
    uploadImg() {
      this.$refs.imgupload.click();
    },
    async beforeUpload(file) {
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Imgesupload'
      );
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let options = {
        callback: data.callback
      };
      options.callback.customValue.filename = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      ); //原文件名称
      let date = new Date();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let result = await client.put(
        data.path +
          year +
          '/' +
          month +
          '/' +
          this.$md5(date) +
          '.' +
          fileExtension,
        file,
        options
      );
      if (result.data.errno === 0) {
        this.$message.success('文件上传成功');
        this.icon = result.data.data;
      } else {
        this.$$message.error('文件上传失败');
      }
    },
    sort(type, item, index) {
      let list = [];
      list = [...this.typeList];
      if (type == 'up') {
        if (index <= 0) {
          return false;
        } else {
          let after = list[index];
          let front = list[index - 1];
          list[index - 1] = after;
          list[index] = front;
        }
      } else if (type == 'down') {
        if (index >= list.length - 1) {
          return false;
        } else {
          let front = list[index];
          let after = list[index + 1];
          list[index + 1] = front;
          list[index] = after;
        }
      }
      let ids = [];
      list.forEach(item => {
        ids.push(item.id);
      });
      this.$http
        .post('/api/app/quicktypelistorder', {
          ids: ids.join(',')
        })
        .then(res => {
          if (res.data.state == 200) {
            this.getTypeList();
          }
        });
    }
  }
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}
.lists {
  position: absolute;
}
.lists ul {
  width: 200px;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
}
.lists li {
  border-top: 1px solid #e8e8e8;
  margin-top: -1px;
  padding-left: 20px;
  width: 200px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}
.lists li.current {
  background-color: #e6f7ff;
}
.lists li.type {
  padding-left: 5px;
}
.lists input {
  width: 70%;
}
.lists li.add {
  padding-left: 0;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
}
.lists .icon {
  margin-right: 5px;
}
.lists .operate {
  position: absolute;
  right: 5px;
  display: none;
}
.lists .operate2 {
  display: none;
}
.lists li:hover .operate2 {
  display: inline-block;
}
.lists li:hover .operate {
  display: inline-block;
}
.dynamic-delete-button,
.dynamic-ok-button {
  left: 5px;
  cursor: pointer;
  position: relative;
  font-size: 18px;
  color: #999;
  transition: all 0.3s;
  margin-right: 5px;
}
.dynamic-ok-button:hover {
  color: #52c41a;
}
.dynamic-ok-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.itemList {
  position: absolute;
  left: 240px;
  right: 0;
}

.itemList .button {
  position: absolute;
  right: 10px;
}
.item {
  position: absolute;
  top: 40px;
  right: 10px;
  bottom: 0;
  left: 0;
}
.item li {
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  border-bottom: 1px solid #dedede;
}
.item li:hover {
  background-color: #efefef;
}
.item li span {
  color: #ccc;
  margin-right: 5px;
}
.item li .operate {
  display: none;
  position: absolute;
  right: 10px;
}
.item li:hover .operate {
  display: inline;
}
.item li .operate button {
  color: #ccc;
}
.item li .operate button:hover {
  color: #1890ff;
}
.margin-l-5 {
  margin-left: 5px;
}
.soft {
  font-size: 8px;
  cursor: pointer;
  position: relative;
}
</style>
